import { useContext, useState } from 'react'

import { useCallLogout, useMeGetApi } from '@/common/api/modules/auth'
import { statusCodeErrorMessage } from '@/common/app/error'
import { LocalStorage, removeStorage } from '@/common/util/storage'

import HeaderHelpButton from '@/components/view/atoms/button/HeaderHelpButton'
import DisclosureRow from '@/components/view/atoms/disclosure/DisclosureRow'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import {
  DisclosurePositionHorizon,
  DisclosurePositionVertical
} from '@/components/view/layouts/disclosure/Disclosure'
import DisclosureWrapper from '@/components/view/layouts/disclosure/DisclosureWrapper'
import { MessageType } from '@/components/view/molecules/bar/MessageBar'
import Header from '@/components/view/molecules/header/Header'
import Menu from '@/components/view/molecules/menu/Menu'

import { AppHeaderStateContext } from '@/components/container/layout/AppHeaderProvider'
import { PasswordModalContext } from '@/components/container/modal/password/PasswordModalProvider'
import { ToastMessageContext } from '@/components/container/utils/message/ToastMessageProvider'

const MenuDisclosure = () => {
  const [showing, setShowing] = useState<boolean>(false)
  const { data } = useMeGetApi()
  const { addMessage } = useContext(ToastMessageContext)
  const { showModal: showPasswordModal } = useContext(PasswordModalContext)

  const logout = useCallLogout({
    onSuccess: () => {
      // セッショントークンを LocalStorage から削除してから遷移する。
      // 削除しないとリダイレクト先で旧トークンが付与され、無効化された
      // セッションに対して 401 が返り「不正な〜」エラーメッセージが出てしまう。
      removeStorage(LocalStorage.AUTH_TOKEN)
      addMessage({ text: 'ログアウトしました。', type: MessageType.SUCCESS })
      window.location.href = '/'
    },
    onError: (error) => {
      // ログアウト要求が失敗してもクライアント側のトークンは破棄する
      removeStorage(LocalStorage.AUTH_TOKEN)
      addMessage({
        text: statusCodeErrorMessage(error.status),
        type: MessageType.CRITICAL
      })
    }
  })

  return (
    <DisclosureWrapper
      horizon={DisclosurePositionHorizon.LEFT}
      vertical={DisclosurePositionVertical.BOTTOM}
      disclosureNode={
        <>
          <DisclosureRow onClick={() => showPasswordModal({})}>
            <Text size={14} lineHeight={150}>
              パスワード変更
            </Text>
          </DisclosureRow>
          <DisclosureRow onClick={() => logout()}>
            <Text size={14} lineHeight={150}>
              ログアウト
            </Text>
          </DisclosureRow>
        </>
      }
      off={!showing}
      onClickOutSide={() => setShowing(false)}
    >
      <Menu onClick={() => setShowing(true)} isOpen={showing}>
        {data?.name ?? '　　　　　'}
      </Menu>
    </DisclosureWrapper>
  )
}

const HelpDisclosure = () => {
  const [showing, setShowing] = useState<boolean>(false)

  return (
    <DisclosureWrapper
      vertical={DisclosurePositionVertical.BOTTOM}
      horizon={DisclosurePositionHorizon.CENTER}
      disclosureNode={
        <>
          <DisclosureRow newTab disabled>
            <Text size={14} lineHeight={150} color={TextColor.DISABLED}>
              お問い合わせ(準備中)
            </Text>
          </DisclosureRow>
          <DisclosureRow disabled>
            <Text size={14} lineHeight={150} color={TextColor.DISABLED}>
              ご意見(準備中)
            </Text>
          </DisclosureRow>
          <DisclosureRow newTab disabled>
            <Text size={14} lineHeight={150} color={TextColor.DISABLED}>
              サポートサイト(準備中)
            </Text>
          </DisclosureRow>
        </>
      }
      off={!showing}
      onClickOutSide={() => setShowing(false)}
    >
      <HeaderHelpButton onClick={() => setShowing(true)} />
    </DisclosureWrapper>
  )
}

interface Props {
  isAdmin?: boolean
}

const AppHeader = ({ isAdmin = false }: Props) => {
  const { hiding } = useContext(AppHeaderStateContext)

  return (
    <Header
      // subText='2024/03~'
      // onSearch={() => {}}
      // サポートサイトへの遷移にするとのことなので、非表示とする
      // helpNode={
      //   isAdmin && (
      //     <>
      //       <TextButton color={TextColor.ON_BG_FILL} link={proposalPath()}>
      //         <Icon type={IconType.BEGINNER} color={IconColor.ON_COLOR} />
      //         Reco-Media
      //         <Icon type={IconType.ARROW_RIGHT} color={IconColor.ON_COLOR} />
      //       </TextButton>
      //       <TextButton color={TextColor.ON_BG_FILL} link={proposal2Path()}>
      //         <Icon type={IconType.BEGINNER} color={IconColor.ON_COLOR} />
      //         Media-DRIVERとは
      //         <Icon type={IconType.ARROW_RIGHT} color={IconColor.ON_COLOR} />
      //       </TextButton>
      //       <HelpDisclosure />
      //     </>
      //   )
      // }
      menuNode={<MenuDisclosure />}
      hiding={hiding}
      isAdmin={isAdmin}
    />
  )
}

export default AppHeader
